import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { getAllTransfer } from "../../actions/transfer";

import RenderTable from "./RenderTable";

import { Layout, Breadcrumb, Row, Col, Spin   } from "antd";
const { Content } = Layout;

const ProductDetails = ({ getAllTransfer, Auth }) => {
  const [details, setdetails] = useState([]);
  const pageno = useRef(1);
  const page_size = useRef(15);
  const [reload, setReload] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllTransfer(pageno.current, page_size.current).then(function (result) {
      setLoading(true);
      // console.log(result);
      setdetails(result);
      setLoading(false);
    });
  }, [reload]);

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Transfer</Breadcrumb.Item>
        <Breadcrumb.Item>All</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        {loading ? (
            <Spin size="large" style={{ display: "block", textAlign: "center", marginTop: "20%" }} />
          ) : (
          <RenderTable 
          details={details} 
          Auth={Auth}
          pageno={pageno}
          page_size={page_size}
          reload={reload}
          setReload={setReload}
          />
          )}
        </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, { getAllTransfer })(ProductDetails);
